import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useCurrentUsage(companyId?: string, systemCode?: string) {
  return useQuery({
    queryKey: ['current-usage', companyId, systemCode],
    queryFn: async () => {
      if (!companyId || !systemCode) return null;

      // Buscar system_id
      const { data: system } = await supabase
        .from('systems')
        .select('id')
        .eq('code', systemCode)
        .single();

      if (!system) return null;

      // Buscar contadores de uso do mês atual
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      const { data: counters } = await supabase
        .from('usage_counters')
        .select('*')
        .eq('company_id', companyId)
        .eq('system_id', system.id)
        .gte('period_start', startOfMonth.toISOString().split('T')[0])
        .lte('period_end', endOfMonth.toISOString().split('T')[0]);

      // Buscar contagens diretas
      const usersResult = await supabase.from('user_companies').select('*', { count: 'exact', head: true }).eq('company_id', companyId);
      const vehiclesResult = await supabase.from('fleet_vehicles').select('*', { count: 'exact', head: true }).eq('company_id', companyId).eq('status', 'active');
      
      const usersCount = usersResult.count || 0;
      const vehiclesCount = vehiclesResult.count || 0;
      const gpsVehiclesCount = 0; // Implementar posteriormente
      const gpsDevicesCount = 0; // Implementar posteriormente

      // Montar objeto de uso
      const usage: Record<string, number> = {
        users: usersCount || 0,
        vehicles: vehiclesCount || 0,
        gps_vehicles: gpsVehiclesCount || 0,
        gps_devices: gpsDevicesCount || 0,
      };

      // Adicionar contadores temporais
      counters?.forEach(counter => {
        usage[counter.metric] = counter.value;
      });

      return usage;
    },
    enabled: !!companyId && !!systemCode,
    staleTime: 30 * 1000, // 30 segundos
  });
}
